import { Breadcrumbs, Link, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isAusDomain } from "../clinicalNotesClinicalRoute/lib/utils";

const helpfulPDFs = [
  {
    id: 1,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/01.%20Creating%20a%20New%20Clinical%20Note.pdf",
    name: "Creating a New Clinical Note",
  },
  {
    id: 2,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/02.%20Creating%20a%20New%20Client%20Profile.pdf",
    name: "Creating a New Client Profile",
  },
  {
    id: 3,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/03.%20Using%20Voice%20Transcription.pdf",
    name: "Using Voice Transcription",
  },
  {
    id: 4,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/04.%20Uploading%20Documents.pdf",
    name: "Uploading Documents",
  },
  {
    id: 5,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/05.%20Navigating%20a%20Clinical%20Note.pdf",
    name: "Navigating a Clinical Note",
  },
  {
    id: 6,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/06.%20Recommending%20Resources%20to%20Patients.pdf",
    name: "Recommending Resources to Patients",
  },
  {
    id: 7,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/07.%20Editing%20Your%20Profile.pdf",
    name: "Editing Your Profile",
  },
  {
    id: 8,
    link: "https://images.unitedwecare.com/odoo/open/webapp/co-pilot/helpcenter/08.%20Contacting%20Support.pdf",
    name: "Contacting Support",
  },
];

const ausHelpfulPDFs = [
  {
    id: 1,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_17%3A41%3A55_1.%20Creating%20new%20Clinical%20note.pdf?alt=media&token=4d941f20-20b0-48b0-92a7-b767f987649c",
    name: "Creating a New Clinical Note",
  },
  {
    id: 2,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_17%3A47%3A10_2.%20Creating%20a%20New%20Patient%20Profile.pdf?alt=media&token=6ea9399a-fff6-4590-82dd-4dd86564a4f4",
    name: "Creating a New Client Profile",
  },
  {
    id: 3,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_17%3A50%3A53_3.%20Using%20Voice%20Transcription.pdf?alt=media&token=b35e4492-0563-4f10-8a8a-b4de61503633",
    name: "Using Voice Transcription",
  },
  {
    id: 4,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_17%3A52%3A44_4.%20Uploading%20Documents.pdf?alt=media&token=b7ed79db-f803-4e1f-877d-26d9cf813c3c",
    name: "Uploading Documents",
  },
  {
    id: 5,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_17%3A55%3A06_5.%20Navigating%20a%20Clinical%20Note.pdf?alt=media&token=da23a023-575e-487f-b23e-3ab015595bb2",
    name: "Navigating a Clinical Note",
  },
    {
    id: 6,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_17%3A55%3A06_5.%20Navigating%20a%20Clinical%20Note.pdf?alt=media&token=da23a023-575e-487f-b23e-3ab015595bb2",
    name: "Editing Your Profile",
  },
  {
    id: 7,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_18%3A01%3A40_7.%20Contacting%20Support.pdf?alt=media&token=d84e2250-d59e-47a3-a030-9d068de894dd",
    name: "Connecting Support",
  },
  {
    id: 8,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_18%3A06%3A56_8.%20Using%20Letter%20Templates.pdf?alt=media&token=44f2a5cf-c768-4e3b-8f45-f3b02352e113",
    name: "Using Letter Templates",
  },
  {
    id: 9,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-02_18%3A13%3A58_9.%20Reviewing%20and%20Upgrading%20Plans.pdf?alt=media&token=9fdc690b-7e07-4baa-a5b8-d7be37a3d76c",
    name: "Reviewing and Upgrading Plans",
  },
    {
    id: 10,
    link: "https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/clinic-data-storage%2Fclients%2Fnull%2F2025-Jul-03_12%3A36%3A54_10.%20Using%20the%20Ask%20Sam%20Virtual%20Assistant.pdf?alt=media&token=b301041f-7dfc-48e2-abd5-6e6d189fa643",
    name: "Using the Ask Sam Virtual Assistant",
  },
];

function HelpCenterDocuments() {
  const navigate = useNavigate();
  return (
    <div className="mt-3 ExpertHelpCenter--Dashboard">
      <div className="ExpertHelpCenter--Header d-flex justify-content-between align-items-center">
        <div role="presentation">
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              onClick={() => {
                navigate("/clinical/help-center");
              }}
              role="button"
              color="text.primary"
              sx={{
                fontWeight: "500",
                fontSize: "20px",
                textDecoration: "none",
              }}
              className="d-flex text-secondary align-items-center justify-content-between gap-2 "
            >
              Help Center
            </Link>

            <Typography
              sx={{ fontWeight: "500", fontSize: "20px" }}
              color="text.primary"
            >
              Documents
            </Typography>
          </Breadcrumbs>
        </div>
      </div>
      <div className="d-none">
        <Typography
          sx={{ fontWeight: "500", fontSize: "24px" }}
          className="mt-3"
          color="text.primary"
        >
          Documentation & Guides
        </Typography>
        <p style={{ fontSize: "1rem" }} className="mt-3 mb-5">
          Find manuals, how-to PDFs, white papers, case studies, and other
          resources to help you use our services.
        </p>
      </div>

      <div className="ExpertHelpCenter--documents">
        {isAusDomain()
          ? ausHelpfulPDFs.map((item) => (
              <div
                className="cursor-pointer  shadow-sm help_center_documents"
                key={item.id}
                onClick={() => window.open(item.link)}
                data-help-center-document={item.link}
                style={{
                  cursor: "pointer",
                  background: "white",
                  borderRadius: "5px",
                  maxWidth: "160px",
                }}
              >
                <div
                  style={{ background: "#D0D5DD", borderRadius: "5px 5px 0 0" }}
                  className="w-100 py-3 pe-3 d-flex align-items-center justify-content-center"
                >
                  <img
                    src={"/assets/img/help-center-assets/Pdf-type.png"}
                    alt="..."
                  />
                </div>
                <div className="py-3 px-2">
                  <span
                    className=" fw-semibold line-clamp "
                    style={{ fontSize: "0.75rem", lineHeight: "120%" }}
                  >
                    {item.name}
                  </span>
                </div>
              </div>
            ))
          : helpfulPDFs.map((item) => (
              <div
                className="cursor-pointer  shadow-sm help_center_documents"
                key={item.id}
                onClick={() => window.open(item.link)}
                data-help-center-document={item.link}
                style={{
                  cursor: "pointer",
                  background: "white",
                  borderRadius: "5px",
                  maxWidth: "160px",
                }}
              >
                <div
                  style={{ background: "#D0D5DD", borderRadius: "5px 5px 0 0" }}
                  className="w-100 py-3 pe-3 d-flex align-items-center justify-content-center"
                >
                  <img
                    src={"/assets/img/help-center-assets/Pdf-type.png"}
                    alt="..."
                  />
                </div>
                <div className="py-3 px-2">
                  <span
                    className=" fw-semibold line-clamp "
                    style={{ fontSize: "0.75rem", lineHeight: "120%" }}
                  >
                    {item.name}
                  </span>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}

export default HelpCenterDocuments;
